<div [class]="getClass()">
  <div class="rs-patch-content text-center">
    <ng-content></ng-content>
  </div>
</div>
